// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"84":"npm.msw","385":"npm.bundled-es-modules","518":"npm.mswjs"}[chunkId] || chunkId) + "." + {"9":"9665a8a1","84":"c26ddf4a","385":"351f477c","518":"ef9e642f"}[chunkId] + ".js";
};